import React, { useContext, useEffect, useState } from "react";

import { Box, Button, Typography } from "@mui/material";
import { AppContext } from "../../AppContextProvider";
import { useNavigate, useParams } from "react-router-dom";
import { REGISTRATION_URL } from "../../MainAppPanel";
import User, { NULL_USER } from "../../models/User";
import { getInvitation } from "../../api/ProcurementClient";
import { SessionInfo } from "../../models/SessionInfo";

export interface LoginResponse extends SessionInfo {
  jwtToken: string;
}

const InvitationPanel: React.FC = () => {
  const { setUser, setUsers, setCustomers } = useContext(AppContext);
  const { inviteId } = useParams();
  const [invitedUser, setInvitedUser] = useState<User | null>();

  const navigate = useNavigate();

  useEffect(() => {
    // Invite links should work even if another account is already logged in
    localStorage.removeItem("jwtToken");
    setUser(NULL_USER);
    setUsers([]);
    setCustomers([]);

    const fetchInvitation = async () => {
      const user = await getInvitation(inviteId!);
      setInvitedUser(user ? user : null);
    };
    fetchInvitation();
  }, []);

  let buttons = <></>;
  let body = (
    <Typography textAlign="center">
      Please wait while we look up your invitation...
    </Typography>
  );

  if (invitedUser) {
    body = (
      <Typography textAlign="center">
        Click below to create an account.
      </Typography>
    );
    buttons = (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={() => navigate(REGISTRATION_URL + "/" + inviteId)}
        >
          Create Account
        </Button>
        <Button variant="contained" onClick={() => navigate("/")}>
          No, Thank You
        </Button>
      </Box>
    );
  } else if (invitedUser === null) {
    body = (
      <Typography textAlign="center">Unable to find invitation.</Typography>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          flexBasis: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            padding: 2,
            display: "flex",
            gap: 2,
            flexDirection: "column",
            width: "80%",
            maxWidth: "400px",
          }}
        >
          <img
            src="/logo.jpg"
            style={{ display: "block", width: "100%", height: "auto" }}
            alt="logo"
          />
          <Typography textAlign="center" variant="h6">
            Procurement Invitation
          </Typography>
          {body}
          {buttons}
        </Box>
      </Box>
    </Box>
  );
};
export default InvitationPanel;
